import '../../scss/product.scss';
import ProductPresenter from './presenters/ProductPresenter';

const init = (product, rules) => new ProductPresenter(product, rules);

window.FND = window.FND || {};
FND.BMS = FND.BMS || {};
FND.BMS.BUILDS = FND.BMS.BUILDS || {};
FND.BMS.BUILDS.Product = init